import { AutoStories, ExpandLess, ExpandMore } from '@mui/icons-material';
import SettingsIcon from '@mui/icons-material/Settings';
import { Collapse, Divider, Drawer, List, ListItemButton, ListItemIcon, ListItemText, useTheme } from '@mui/material';
import Icon from '@mui/material/Icon';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { PRIMARY_COLOR } from '../../_const/color.const';
import { ADMIN_NAV, PRIMARY_NAV, USER_NAV, AGENT_NAV, REPORTS_NAV, CLIENT_NAV, USER_NAV1 } from '../../_const/navigation.const';
import { accountService } from '../../_services/accounts.service';
import { ChatSidebar } from '../chat/chat.sidebar';

const drawerWidth = 240;

export function AppSidebar(params: {
    isOpen: boolean,
    variant?: "persistent" | "temporary";
    onClose?: () => void;
    /** Close overlay drawer after a nav item is chosen (mobile). */
    onNavigated?: () => void;
    currentUser: any,
    users: any[],
    groups: any[],
    activeRecipient: any,
    activeGroup: any,
    onSelectRecipient: (user: any) => void,
    onSelectGroup: (group: any) => void,
    onGroupManage?: (group?: any) => void;
    children?: React.ReactNode
}) {

    let navigate = useNavigate();
    const theme = useTheme();
    const variant = params.variant ?? "persistent";
    const isTemporary = variant === "temporary";

    const go = (url: string) => {
        navigate(url);
        if (isTemporary) params.onNavigated?.();
    };

    const [isOpen, setIsOpen] = useState(params.isOpen);
    const [setupNavOpen, setSetupNavOpen] = useState(false);
    const [uploadNavOpen, setUploadNavOpen] = useState(false);
    const [selectedListItem, setSelectedListItem] = useState(null);
    const [reportNavOpen, setReportNavOpen] = useState(false);

    const handleSelectedItemClick = (item: any) => {
        setSelectedListItem(item);
    };

    useEffect(() => {
        setIsOpen(params.isOpen);
    }, [params.isOpen]);



    return (
        <Drawer
            sx={{
                width: drawerWidth,
                flexShrink: 0,
                "& .MuiDrawer-paper": isTemporary
                    ? {
                          width: drawerWidth,
                          top: 56,
                          height: "calc(100% - 56px)",
                          paddingTop: 0,
                          boxSizing: "border-box",
                      }
                    : {
                          width: drawerWidth,
                          top: { xs: 56, md: 64 },
                          height: { xs: "calc(100% - 56px)", md: "calc(100% - 64px)" },
                          paddingTop: 0,
                          boxSizing: "border-box",
                          zIndex: theme.zIndex.drawer,
                      },
            }}
            variant={variant}
            open={isOpen}
            onClose={isTemporary ? params.onClose : undefined}
            ModalProps={
                isTemporary
                    ? {
                          keepMounted: false,
                          sx: { zIndex: theme.zIndex.modal },
                      }
                    : undefined
            }
            id={"sidebarNavDrawer"}
            anchor="left">

            {(PRIMARY_NAV.length > 0 && (accountService.isAdmin || accountService.isUser)) &&
                <List>
                    {PRIMARY_NAV.map(nav =>
                        <ListItemButton key={nav.name} onClick={e => go(nav.url)}>
                            <ListItemIcon><Icon>{nav.icon}</Icon></ListItemIcon>
                            <ListItemText primary={nav.name} />
                        </ListItemButton>
                    )}

                    {!accountService.isClient &&
                        <Divider sx={{ marginTop: "8px" }} />
                    }
                </List>
            }

            {(AGENT_NAV.length > 0 && accountService.isAgent) &&
                <List>
                    {AGENT_NAV.map(nav =>
                        <ListItemButton key={nav.name} onClick={e => go(nav.url)}>
                            <ListItemIcon><Icon>{nav.icon}</Icon></ListItemIcon>
                            <ListItemText primary={nav.name} />
                        </ListItemButton>
                    )}
                </List>
            }

            {(CLIENT_NAV.length > 0 && accountService.isClient) &&
                <List>
                    {CLIENT_NAV.map(nav =>
                        <ListItemButton key={nav.name} onClick={e => go(nav.url)}>
                            <ListItemIcon><Icon>{nav.icon}</Icon></ListItemIcon>
                            <ListItemText primary={nav.name} />
                        </ListItemButton>
                    )}
                </List>
            }

            {(USER_NAV1.length > 0 && accountService.isUser) &&
                <List>
                    {USER_NAV1.map(nav =>
                        <ListItemButton key={nav.name} onClick={e => go(nav.url)}>
                            <ListItemIcon><Icon>{nav.icon}</Icon></ListItemIcon>
                            <ListItemText primary={nav.name} />
                        </ListItemButton>
                    )}
                </List>
            }

            {ADMIN_NAV.length > 0 &&
                <>
                    {accountService.isAdmin &&
                        <List
                            sx={{ width: '100%', paddingTop: "0px", maxWidth: 360 }}
                            component="nav"
                            aria-labelledby="nested-list-subheader">

                            <ListItemButton sx={{ marginTop: "0px", paddingTop: "0px" }} onClick={(e) => setSetupNavOpen(!setupNavOpen)}>
                                <ListItemIcon>
                                    <SettingsIcon />
                                </ListItemIcon>
                                <ListItemText primary="Setup" />
                                {setupNavOpen ? <ExpandLess /> : <ExpandMore />}
                            </ListItemButton>
                            <Collapse in={setupNavOpen} timeout="auto" unmountOnExit>
                                <List component="div">

                                    {ADMIN_NAV.map(nav => <ListItemButton
                                        sx={selectedListItem === nav ? {
                                            backgroundColor: PRIMARY_COLOR,
                                            color: '#fff',
                                            pl: 4,
                                            marginLeft: '26px',
                                            paddingLeft: '12px',
                                            borderLeft: '1px solid grey',
                                            "&:hover": {
                                                backgroundColor: PRIMARY_COLOR,
                                                opacity: 0.7,
                                            }
                                        } : {
                                            backgroundColor: 'auto',
                                            color: 'auto',
                                            pl: 4,
                                            marginLeft: '26px',
                                            paddingLeft: '12px',
                                            borderLeft: '1px solid grey'
                                        }}
                                        key={nav.name}
                                        onClick={e => { go(nav.url); handleSelectedItemClick(nav); }}
                                    >
                                        <>
                                            <ListItemIcon>
                                                <Icon
                                                    fontSize="small"
                                                    sx={selectedListItem === nav ? {
                                                        color: '#fff',
                                                    } : { color: "disabled" }}>
                                                    {nav.icon}
                                                </Icon>
                                            </ListItemIcon>
                                            <ListItemText
                                                primaryTypographyProps={{ fontSize: '14px' }}
                                                primary={nav.name} />
                                        </>
                                    </ListItemButton>
                                    )}

                                </List>
                            </Collapse>

                            <ListItemButton onClick={(e) => setReportNavOpen(!reportNavOpen)}>
                                <ListItemIcon>
                                    <AutoStories />
                                </ListItemIcon>
                                <ListItemText primary="Reports" />
                                {reportNavOpen ? <ExpandLess /> : <ExpandMore />}
                            </ListItemButton>
                            <Collapse in={reportNavOpen} timeout="auto" unmountOnExit>
                                <List component="div">

                                    {REPORTS_NAV.map(nav =>
                                        <ListItemButton sx={{ pl: 4, marginLeft: '26px', paddingLeft: '12px', borderLeft: '1px solid' }} key={nav.name} onClick={e => go(nav.url)}>
                                            <>
                                                <ListItemIcon><Icon fontSize="small" color="disabled">{nav.icon}</Icon></ListItemIcon>
                                                <ListItemText
                                                    primaryTypographyProps={{ fontSize: '14px' }}
                                                    primary={nav.name} />
                                            </>
                                        </ListItemButton>
                                    )}

                                </List>
                            </Collapse>
                        </List>
                    }
                </>
            }

            {(USER_NAV.length > 0) &&
                <List>
                    <Divider />

                    {USER_NAV.map(nav =>
                        <ListItemButton key={nav.name} onClick={nav.onClick} sx={{ marginTop: "8px" }}>
                            <ListItemIcon><Icon>{nav.icon}</Icon></ListItemIcon>
                            <ListItemText primary={nav.name} />
                        </ListItemButton>
                    )}
                    <Divider sx={{ marginTop: "8px" }} />
                </List>
            }

            {(accountService.isAdmin || accountService.isUser) &&
                <ChatSidebar
                    currentUser={params.currentUser}
                    users={params.users}
                    groups={params.groups}
                    activeRecipient={params.activeRecipient}
                    activeGroup={params.activeGroup}
                    onSelectUser={params.onSelectRecipient}
                    onSelectGroup={params.onSelectGroup}
                    onGroupManage={params.onGroupManage}
                />
            }
        </Drawer>
    );
}